'use strict';

import $ from 'jquery';
import { lib } from '../../common/Library';
import Sortable from '../../../vendor/Sortable/Sortable.min.js';

require('../../../vendor/jquery.balloon.js/jquery.balloon.min.js');
require('../../../vendor/jQuery-Validation-Engine/jquery.validationEngine-ja.js');
require('../../../vendor/jQuery-Validation-Engine/jquery.validationEngine.min.js');
require('../../../vendor/jQuery-Validation-Engine/validationEngine.jquery.min.css');
require('../../../vendor/jquery.ui.labeledslider/jquery.ui.labeledslider.min.js');
require('../../../vendor/jquery.ui.labeledslider/jquery.ui.labeledslider.min.css');

require('./main_chart.js');

// 数値を書き換え中などの処理中の時、銘柄件数を更新させないためのフラグ
let globalLoadFlg = false;

function getScreeningConf(section) {
    section = section || null;

    const config = JSON.parse($('#screeningConfJson').val());

    if (section === null || config === null) {
        return config;
    } else if (section in config) {
        return config[section];
    }

    return null;
}

function getInitInput(section) {
    section = section || null;

    const initInput = JSON.parse($('#initInputJson').val());

    if (section === null || initInput === null) {
        return initInput;
    } else if (section in initInput) {
        return initInput[section];
    }

    return null;
}

let detailConfJson = getScreeningConf('detail'),
    detailLimit = getScreeningConf('limit'), // 詳細条件選択上限
    categoryConfJson = getScreeningConf('category'),
    plConfJson = getScreeningConf('pl'),
    roundConf = getScreeningConf('round'); // 有効小数点桁数

/**
 * 詳細条件入力行を追加
 */
$(function() {
    try {
        let inputDetailInitVal = getInitInput('detail'), // 詳細条件数値
            tmpInitVal,
            screeningJson,
            $htmlParts,
            idNum,
            inputChecked,
            type,
            title,
            plName,
            unit,
            subtitle,
            limitClass;

        // 詳細条件追加モーダルからチェックボックスが押下された時
        $(document).on(
            'ifToggled',
            '#detail_modal .check_list .row input',
            function() {
                // クリックした要素のidを取得
                let id = $(this)
                    .closest('.row')
                    .attr('id');
                makeDetailRow(id);

                // マイスクリーニング設定モーダル表示チェック
                // saveModalLimitCheck();
            }
        );

        /**
         * 詳細条件行を生成する
         * @param {type} id
         */
        function makeDetailRow(id) {
            if (detailConfJson === null) {
                return;
            }

            // idから数値部分を抽出
            idNum = id.split('_')[1];

            // スクリーニングJSONから該当データを抽出
            if (idNum in detailConfJson) {
                screeningJson = detailConfJson[idNum];
            }

            // 該当IDの設定ファイルが存在しない
            if (screeningJson === undefined) {
                throw new Error('screeningJson in undefined  id=' + idNum);
            }

            // チェック状態を取得
            inputChecked = $('#' + id + ' input').prop('checked');

            // 入力タイプ
            type = screeningJson.type;
            // タイトル
            title = screeningJson.name;
            // PL4項目名
            plName = null;
            if (screeningJson.pl !== undefined) {
                plName = plConfJson[screeningJson.pl];
            }
            // 単位
            unit = screeningJson.unit;
            // カテゴリタイトル
            subtitle = categoryConfJson[screeningJson.category].name;
            // 入力欄テンプレートから要素をコピー
            $htmlParts = $('#' + type).clone(true);

            // 制限項目か確認
            if (screeningJson.limit_screening) {
                limitClass = 'limit_screening';
            } else {
                limitClass = '';
            }

            if (inputChecked === true) {
                $htmlParts
                    .children('.row')
                    .attr('id', 'detail_' + id)
                    .addClass(limitClass);

                // 項目タイトル
                if (plName === null) {
                    $htmlParts.find('.maintitle').text(title);
                } else {
                    $htmlParts
                        .find('.maintitle')
                        .text(title + '（' + plName + '）');
                }

                // 項目サブタイトル
                $htmlParts.find('.subtitle').text('[' + subtitle + ']');

                // input nameを追加
                $htmlParts.find('.v1').attr('name', id + '_1');
                $htmlParts.find('.v2').attr('name', id + '_2');
                $htmlParts.find('.v3').attr('name', id + '_3');
                $htmlParts.find('.v4').attr('name', id + '_4');

                // 単位
                $htmlParts.find('.unit').text(unit);

                // radio idを追加
                $htmlParts
                    .find('.select_btn input[type=radio]')
                    .each(function(idx) {
                        $(this).attr('id', 'radio_' + id + '_' + idx);
                    });

                $htmlParts.find('.select_btn label').each(function(idx) {
                    $(this).attr('for', 'radio_' + id + '_' + idx);
                });

                // select生成
                if ($htmlParts.find('select')) {
                    if ('select' in screeningJson) {
                        makeSelect(screeningJson);
                    }

                    if ('select_from' in screeningJson) {
                        makeSelectRange(screeningJson, 'from');
                    }

                    if ('select_to' in screeningJson) {
                        makeSelectRange(screeningJson, 'to');
                    }
                }

                // radio生成
                if ('radio' in screeningJson && $htmlParts.find('.radio')) {
                    makeRadio(screeningJson, id);
                }

                // check生成
                if ('check' in screeningJson && $htmlParts.find('.check')) {
                    makeCheck(screeningJson, id);
                }

                // 行を追加
                $('.detail_condition_list').append($htmlParts.html());

                // チェックボックスにiCheck適用
                if ('check' in screeningJson && $htmlParts.find('.check')) {
                    $('#detail_' + id + ' input[type="checkbox"]').iCheck({
                        // チェックボックスのスタイル設定
                        checkboxClass: 'icheckbox_flat-green'
                    });
                }

                // スライダー生成(後付け)
                if ('slider' in screeningJson) {
                    let $detailRow = $('#detail_' + id),
                        sliderJson = screeningJson.slider;

                    if ($detailRow.find('.normal .slider').length > 0) {
                        tmpInitVal = null;
                        $.each(inputDetailInitVal, function(idx, data) {
                            if (data.id == idNum) {
                                tmpInitVal = data;
                                return false; // break;
                            }
                        });
                        $detailRow.find('.slider').attr('id', 'slider_' + id); // スライダー本体
                        $detailRow
                            .find('.slider_start')
                            .attr('id', 'slider_start_' + id);
                        $detailRow
                            .find('.slider_end')
                            .attr('id', 'slider_end_' + id);
                        makeNormalSlider(sliderJson, id, tmpInitVal);
                    } else if ($detailRow.find('.prog .slider').length > 0) {
                        tmpInitVal = null;
                        $.each(inputDetailInitVal, function(idx, data) {
                            if (data.id == idNum) {
                                tmpInitVal = data;
                                return false; // break;
                            }
                        });
                        $detailRow.find('.slider').attr('id', 'slider_' + id); // スライダー本体
                        $detailRow
                            .find('.slider_start')
                            .attr('id', 'slider_start_' + id);
                        $detailRow
                            .find('.slider_end')
                            .attr('id', 'slider_end_' + id);
                        makeProgSlider(sliderJson, id, tmpInitVal);
                    } else if (
                        $detailRow.find('.stockPrice .slider').length > 0
                    ) {
                        // 株価レンジ
                        tmpInitVal = null;
                        $.each(inputDetailInitVal, function(idx, data) {
                            if (data.id == idNum) {
                                tmpInitVal = data;
                                return false; //break;
                            }
                        });
                        $detailRow.find('.slider').attr('id', 'slider_' + id); //スライダー本体
                        $detailRow
                            .find('.slider_start')
                            .attr('id', 'slider_start_' + id);
                        $detailRow
                            .find('.slider_end')
                            .attr('id', 'slider_end_' + id);
                        makeStockPriceSlider(sliderJson, id, tmpInitVal);
                    }
                }
            } else {
                // 要素削除
                $('#detail_' + id).remove();

                // 制限対象の設定項目か確認
                if ($('#' + id).hasClass('limit_screening')) {
                    // 制限対象
                    $('#' + id + ' input').iCheck('disable');
                }
            }

            getStockCnt();
        }

        /**
         * <select>DOMを生成する
         * @param {type} screeningJson
         */
        function makeSelect(screeningJson) {
            let selectedNum = screeningJson.selected,
                selected,
                options;

            options = $.map(screeningJson.select, function(name, value) {
                if (selectedNum == value) {
                    selected = 'selected';
                } else {
                    selected = null;
                }

                return $('<option>', {
                    value: value,
                    text: name,
                    selected: selected
                });
            });

            $htmlParts.find('select').append(options);
        }

        /**
         * <select>from-to版DOMを生成する
         * @param {type} screeningJson
         * @param {type} type
         * @returns {undefined}
         */
        function makeSelectRange(screeningJson, type) {
            let selectedNum, selected, options, procJson;

            if (type === 'from') {
                selectedNum = screeningJson.selected_from;
                procJson = screeningJson.select_from;
            } else if (type === 'to') {
                selectedNum = screeningJson.selected_to;
                procJson = screeningJson.select_to;
            }

            options = $.map(procJson, function(name, value) {
                if (selectedNum == value) {
                    selected = 'selected';
                } else {
                    selected = null;
                }

                return $('<option>', {
                    value: value,
                    text: name,
                    selected: selected
                });
            });

            $htmlParts.find('.' + type + ' select').append(options);
        }

        /**
         * <input type='radio'>DOMを生成する
         * @param {type} screeningJson
         * @param {type} id
         */
        function makeRadio(screeningJson, id) {
            let checkedNum = screeningJson.radioChecked,
                checked,
                $radioContainer = $htmlParts.find('.radio'),
                inputName = $radioContainer.data('value');

            $.each(screeningJson.radio, function(value, name) {
                if (checkedNum == value) {
                    checked = 'checked';
                } else {
                    checked = null;
                }

                // radio
                $radioContainer.append(
                    $('<input>', {
                        type: 'radio',
                        id: 'radio_' + id + '_' + value,
                        name: id + '_' + inputName,
                        value: value,
                        checked: checked
                    })
                );

                // label
                $radioContainer.append(
                    $('<label>', {
                        for: 'radio_' + id + '_' + value,
                        class: 'radio_multiple',
                        text: name
                    })
                );
            });
        }

        /**
         * <input type='checkbox'>DOMを生成する
         * @param {type} screeningJson
         * @param {type} id
         */
        function makeCheck(screeningJson, id) {
            let checkedNum = screeningJson.checked,
                checked,
                $checkboxContainer = $htmlParts.find('.check');

            // 複数
            if (screeningJson.check instanceof Object) {
                $.each(screeningJson.check, function(value, name) {
                    if (value in checkedNum && checkedNum[value] === true) {
                        checked = 'checked';
                    } else {
                        checked = null;
                    }

                    $checkboxContainer.append(
                        $('<label/>')
                            .append(
                                $('<input/>', {
                                    type: 'checkbox',
                                    id: 'check_' + id + '_' + value,
                                    name: id + '_' + value,
                                    value: 1,
                                    checked: checked
                                })
                            )
                            .append(name)
                    );
                });
                // 単体
            } else {
                $htmlParts.find('.check_name').text(screeningJson.check);
            }
        }

        /**
         * スライダー生成
         * @param {type} sliderJson
         * @param {type} id
         * @param {type} initVal
         * @returns {undefined}
         */
        function makeNormalSlider(sliderJson, id, initVal) {
            let tickLabelsKey = {},
                initValueMin,
                initValueMax,
                decimalNum = 0; // 小数の桁数

            // スライダータイトル
            if (sliderJson.name !== undefined) {
                $('#detail_' + id + ' .slider_name').text(sliderJson.name);
            } else {
                $('#detail_' + id + ' .slider_name').hide();
            }

            tickLabelsKey[sliderJson.min] = sliderJson.startStr;
            tickLabelsKey[sliderJson.max] = sliderJson.endStr;

            if (initVal !== undefined && initVal !== null) {
                // 入力された内容を使用
                if ('value_1' in initVal) {
                    initValueMin = parseFloat(initVal.value_1);
                } else {
                    initValueMin = parseFloat(sliderJson.min);
                }

                if ('value_2' in initVal) {
                    initValueMax = parseFloat(initVal.value_2);
                } else {
                    initValueMax = parseFloat(sliderJson.max);
                }
            } else {
                // 初期値
                initValueMin = parseFloat(sliderJson.min);
                initValueMax = parseFloat(sliderJson.max);
            }

            // 小数がある時
            if (sliderJson.step < 1) {
                decimalNum = 1;
            } else if (sliderJson.step < 0.1) {
                decimalNum = 2;
            }

            initValueMin = initValueMin.toFixed(decimalNum);
            initValueMax = initValueMax.toFixed(decimalNum);

            $('#slider_' + id).labeledslider({
                range: true,
                min: sliderJson.min,
                max: sliderJson.max,
                step: sliderJson.step,
                values: [initValueMin, initValueMax],
                tickArray: [sliderJson.min, sliderJson.max],
                tickLabels: tickLabelsKey,
                create: function() {
                    $('input[name="' + id + '_1"]').val(initValueMin);
                    $('input[name="' + id + '_2"]').val(initValueMax);
                    $('#slider_start_' + id).html(initValueMin);
                    $('#slider_end_' + id).html(initValueMax);
                },
                slide: function(event, ui) {
                    let $this = $(this);
                    let sliderId = (function() {
                        let splitSliderId = [];
                        splitSliderId = $this.attr('id').split('_');
                        return splitSliderId[1] + '_' + splitSliderId[2];
                    })();

                    // 小数がある時
                    if (sliderJson.step < 1) {
                        decimalNum = 1;
                    } else if (sliderJson.step < 0.1) {
                        decimalNum = 2;
                    }

                    $('input[name="' + sliderId + '_1"]').val(ui.values[0]);
                    $('input[name="' + sliderId + '_2"]').val(ui.values[1]);

                    $('#slider_start_' + sliderId).html(
                        ui.values[0].toFixed(decimalNum)
                    );
                    $('#slider_end_' + sliderId).html(
                        ui.values[1].toFixed(decimalNum)
                    );
                },
                stop: function() {
                    // 銘柄件数を書き換え
                    getStockCnt();
                }
            });
        }

        /**
         * 進捗率スライダーを生成
         * @param {type} sliderJson
         * @param {type} id
         * @param {type} initVal
         */
        function makeProgSlider(sliderJson, id, initVal) {
            let tickLabelsKey = {},
                initValueMin,
                initValueMax,
                decimalNum = 0; // 小数の桁数

            // スライダータイトル
            if (sliderJson.name !== undefined) {
                $('#detail_' + id + ' .slider_name').text(sliderJson.name);
            } else {
                $('#detail_' + id + ' .slider_name').hide();
            }

            // ラベル
            if (sliderJson.min !== undefined) {
                tickLabelsKey[sliderJson.min] =
                    sliderJson.min + detailConfJson[idNum].unit + '以下';
            }
            if (sliderJson.max !== undefined) {
                tickLabelsKey[sliderJson.max] =
                    sliderJson.max + detailConfJson[idNum].unit + '以上';
            }
            if (sliderJson.center !== undefined) {
                tickLabelsKey[sliderJson.center] =
                    sliderJson.center + detailConfJson[idNum].unit;
            }

            if (initVal !== undefined && initVal !== null) {
                // 入力された内容を使用
                if ('value_1' in initVal) {
                    initValueMin = parseFloat(initVal.value_1);
                } else {
                    initValueMin = parseFloat(sliderJson.min);
                }

                if ('value_2' in initVal) {
                    initValueMax = parseFloat(initVal.value_2);
                } else {
                    initValueMax = parseFloat(sliderJson.max);
                }
            } else {
                // 初期値
                initValueMin = parseFloat(sliderJson.min);
                initValueMax = parseFloat(sliderJson.max);
            }

            // 小数がある時
            if (sliderJson.step < 1) {
                decimalNum = 1;
            } else if (sliderJson.step < 0.1) {
                decimalNum = 2;
            }

            initValueMin = initValueMin.toFixed(decimalNum);
            initValueMax = initValueMax.toFixed(decimalNum);

            $('#slider_' + id).labeledslider({
                range: true,
                min: sliderJson.min,
                max: sliderJson.max,
                step: sliderJson.step,
                values: [initValueMin, initValueMax],
                tickArray: [sliderJson.min, sliderJson.center, sliderJson.max],
                tickLabels: tickLabelsKey,
                create: function() {
                    let sliderIdNum = id.split('_')[1], // id数値部分抽出
                        startNum = initValueMin,
                        endNum = initValueMax,
                        detailUnit = detailConfJson[sliderIdNum].unit || null,
                        // スライダー上部に表示する文字列を取得
                        dispData = getDispStartEndData(
                            sliderJson,
                            startNum,
                            endNum,
                            detailUnit
                        );

                    $('input[name="' + id + '_1"]').val(initValueMin);
                    $('input[name="' + id + '_2"]').val(initValueMax);
                    $('#slider_start_' + id).html(dispData.startNum);
                    $('#slider_end_' + id).html(dispData.endNum);
                    if (dispData.titleFlg) {
                        $('#detail_' + id + ' .tilde').show();
                    } else {
                        $('#detail_' + id + ' .tilde').hide();
                    }
                },
                slide: function(event, ui) {
                    let $this = $(this);
                    let sliderIdNum = (function() {
                        let splitSliderId = [];
                        splitSliderId = $this.attr('id').split('_');
                        return splitSliderId[2];
                    })();
                    let sliderId = (function() {
                        let splitSliderId = [];
                        splitSliderId = $this.attr('id').split('_');
                        return splitSliderId[1] + '_' + splitSliderId[2];
                    })();

                    // 小数がある時
                    if (sliderJson.step < 1) {
                        decimalNum = 1;
                    } else if (sliderJson.step < 0.1) {
                        decimalNum = 2;
                    }

                    let startNum = ui.values[0].toFixed(decimalNum),
                        endNum = ui.values[1].toFixed(decimalNum),
                        detailUnit = detailConfJson[sliderIdNum].unit || null,
                        // スライダー上部に表示する文字列を取得
                        dispData = getDispStartEndData(
                            sliderJson,
                            startNum,
                            endNum,
                            detailUnit
                        );

                    $('input[name="' + sliderId + '_1"]').val(ui.values[0]);
                    $('input[name="' + sliderId + '_2"]').val(ui.values[1]);

                    $('#slider_start_' + sliderId).html(dispData.startNum);
                    $('#slider_end_' + sliderId).html(dispData.endNum);
                    if (dispData.titleFlg) {
                        $('#detail_' + sliderId + ' .tilde').show();
                    } else {
                        $('#detail_' + sliderId + ' .tilde').hide();
                    }
                },
                stop: function() {
                    // 銘柄件数を書き換え
                    getStockCnt();
                }
            });

            let html = $('#detail_' + id)
                .find('.balloon')
                .html();

            $('#detail_' + id)
                .find('.balloon_link')
                .balloon({
                    html: true,
                    contents: html,
                    showDuration: 0,
                    hideDuration: 0,
                    minLifetime: 0,
                    position: 'left bottom',
                    tipSize: 14,
                    classname: 'prog_balloon'
                });
        }

        /**
         * 株価レンジスライダーを生成
         * @param {type} sliderJson
         * @param {type} id
         * @param {type} initVal
         */
        function makeStockPriceSlider(sliderJson, id, initVal) {
            let tickLabelsKey = {},
                tickArraysKey = {},
                initValueMin,
                initValueMax,
                decimalNum = 0; //小数の桁数

            //スライダータイトル
            if (sliderJson.name !== undefined) {
                $('#detail_' + id + ' .slider_name').text(sliderJson.name);
            } else {
                $('#detail_' + id + ' .slider_name').hide();
            }

            let valTemp = null;
            //ラベル：最小値
            if (sliderJson.min !== undefined) {
                valTemp =
                    0 < sliderJson.min ? '+' + sliderJson.min : sliderJson.min;
                tickArraysKey[sliderJson.min] = sliderJson.min;
                tickLabelsKey[sliderJson.min] =
                    valTemp + detailConfJson[idNum].rangeUnit + '以下';
            }
            //ラベル：最大値
            if (sliderJson.max !== undefined) {
                valTemp =
                    0 < sliderJson.max ? '+' + sliderJson.max : sliderJson.max;
                tickArraysKey[sliderJson.max] = sliderJson.max;
                tickLabelsKey[sliderJson.max] =
                    valTemp + detailConfJson[idNum].rangeUnit + '以上';
            }
            //ラベル：中央値
            if (sliderJson.center !== undefined) {
                tickArraysKey[sliderJson.center] = sliderJson.center;
                tickLabelsKey[sliderJson.center] =
                    sliderJson.center + detailConfJson[idNum].rangeUnit;
            }
            // ラベル：その他(labelStep単位)
            if (
                sliderJson.min !== undefined &&
                sliderJson.max !== undefined &&
                sliderJson.center !== undefined
            ) {
                for (
                    let i = sliderJson.min;
                    i < sliderJson.max;
                    i = i + sliderJson.labelStep
                ) {
                    if (
                        i == sliderJson.min ||
                        i == sliderJson.center ||
                        i == sliderJson.max
                    ) {
                        // 最小値・最大値・中央値はSKIP（既に設定済み）
                        continue;
                    } else {
                        valTemp = 0 < i ? '+' + i : i;
                        tickArraysKey[i] = i;
                        tickLabelsKey[i] =
                            valTemp + detailConfJson[idNum].rangeUnit;
                    }
                }
            }

            if (initVal !== undefined && initVal !== null) {
                //入力された内容を使用
                if ('value_1' in initVal) {
                    initValueMin = parseFloat(initVal.value_1);
                } else {
                    initValueMin = parseFloat(sliderJson.min);
                }

                if ('value_2' in initVal) {
                    initValueMax = parseFloat(initVal.value_2);
                } else {
                    initValueMax = parseFloat(sliderJson.max);
                }
            } else {
                //初期値
                initValueMin = parseFloat(sliderJson.min);
                initValueMax = parseFloat(sliderJson.max);
            }

            //小数がある時
            if (sliderJson.step < 1) {
                decimalNum = 1;
            } else if (sliderJson.step < 0.1) {
                decimalNum = 2;
            }

            initValueMin = initValueMin.toFixed(decimalNum);
            initValueMax = initValueMax.toFixed(decimalNum);

            $('#slider_' + id).labeledslider({
                range: true,
                min: sliderJson.min,
                max: sliderJson.max,
                step: sliderJson.step,
                values: [initValueMin, initValueMax],
                tickArray: tickArraysKey,
                tickLabels: tickLabelsKey,
                create: function() {
                    let sliderIdNum = id.split('_')[1], //id数値部分抽出
                        startNum = initValueMin,
                        endNum = initValueMax,
                        detailUnit =
                            detailConfJson[sliderIdNum].rangeUnit || null,
                        //スライダー上部に表示する文字列を取得
                        dispData = getDispStartEndData(
                            sliderJson,
                            startNum,
                            endNum,
                            detailUnit,
                            true
                        );

                    $('input[name="' + id + '_1"]').val(initValueMin);
                    $('input[name="' + id + '_2"]').val(initValueMax);
                    $('#slider_start_' + id).html(dispData.startNum);
                    $('#slider_end_' + id).html(dispData.endNum);
                    if (dispData.titleFlg) {
                        $('#detail_' + id + ' .tilde').show();
                    } else {
                        $('#detail_' + id + ' .tilde').hide();
                    }
                },
                slide: function(event, ui) {
                    let $this = $(this);
                    let sliderIdNum = (function() {
                        let splitSliderId = [];
                        splitSliderId = $this.attr('id').split('_');
                        return splitSliderId[2];
                    })();
                    let sliderId = (function() {
                        let splitSliderId = [];
                        splitSliderId = $this.attr('id').split('_');
                        return splitSliderId[1] + '_' + splitSliderId[2];
                    })();

                    //小数がある時
                    if (sliderJson.step < 1) {
                        decimalNum = 1;
                    } else if (sliderJson.step < 0.1) {
                        decimalNum = 2;
                    }

                    let startNum = ui.values[0].toFixed(decimalNum),
                        endNum = ui.values[1].toFixed(decimalNum),
                        detailUnit =
                            detailConfJson[sliderIdNum].rangeUnit || null,
                        //スライダー上部に表示する文字列を取得
                        dispData = getDispStartEndData(
                            sliderJson,
                            startNum,
                            endNum,
                            detailUnit,
                            true
                        );

                    $('input[name="' + sliderId + '_1"]').val(ui.values[0]);
                    $('input[name="' + sliderId + '_2"]').val(ui.values[1]);

                    $('#slider_start_' + sliderId).html(dispData.startNum);
                    $('#slider_end_' + sliderId).html(dispData.endNum);
                    if (dispData.titleFlg) {
                        $('#detail_' + sliderId + ' .tilde').show();
                    } else {
                        $('#detail_' + sliderId + ' .tilde').hide();
                    }
                },
                stop: function() {
                    //銘柄件数を書き換え
                    getStockCnt();
                }
            });
        }

        /**
         * スライダー上部に表示する文字列を取得
         * @param {Object} sliderJson スライダーコンフィグJSON
         * @param {Number} startNum 開始値
         * @param {Number} endNum 終了値
         * @param {String} unit 単位
         * @returns {Object}
         */
        function getDispStartEndData(sliderJson, startNum, endNum, unit) {
            let titleFlg = true;

            // 全数値
            if (startNum <= sliderJson.min && endNum >= sliderJson.max) {
                startNum = 'すべて';
                endNum = null;
                titleFlg = false;
                // ○○以下
            } else if (startNum <= sliderJson.min) {
                startNum = null;
                endNum = endNum + unit + '以下';
                titleFlg = false;
                // ○○以上
            } else if (endNum >= sliderJson.max) {
                startNum = startNum + unit + '以上';
                endNum = null;
                titleFlg = false;
                // ぴったり
            } else if (startNum === endNum) {
                startNum = startNum + unit;
                endNum = null;
                titleFlg = false;
                // ○○～○○
            } else {
                startNum = startNum + unit;
                endNum = endNum + unit;
                titleFlg = true;
            }

            return {
                startNum: startNum,
                endNum: endNum,
                titleFlg: titleFlg
            };
        }
    } catch (e) {
        console.log(e);
    }
});

/**
 * 詳細条件並び替え
 * @returns {undefined}
 */
$(window).on('load', function() {
    let $detailConditionList = $('.detail_condition_list');

    if ($detailConditionList.length > 0) {
        Sortable.create($detailConditionList[0], {
            animation: 100,
            handle: '.input_area',
            filter: 'input, label', // 無効化箇所
            // 無効化箇所を触った時の動作
            onFilter: function(ev) {
                // フォーカスさせる
                ev.target.focus();
            }
        });
    }
});

/**
 * センタリングを実行
 */
function centeringModal(id, topFix = false) {
    if (id !== undefined) {
        // 画面(ウィンドウ)の幅、高さを取得
        let width = window.innerWidth,
            height = window.innerHeight,
            contentWidth = $(id).outerWidth(),
            contentHeight = $(id).outerHeight();

        // センタリングを実行する
        $(id).css({
            left: (width - contentWidth) / 2 + 'px',
            top: (height - contentHeight) / 3 + 'px'
        });

        // センタリングを実行する
        if (topFix) {
            $(id).css({
                'top': '15px'
            });
        }
    }
}

/**
 * 条件入力欄を開く
 *
 * @param {type} $dom
 */
function openConditionHead($dom) {
    $dom.find('.body').show();
    $dom.find('.head .open').hide();
    $dom.find('.head .close').show();
}

/**
 * 条件入力欄を閉じる
 *
 * @param {type} $dom
 */
function closeConditionHead($dom) {
    $dom.find('.body').hide();
    $dom.find('.head .open').show();
    $dom.find('.head .close').hide();
}

function allCheck($this) {
    $this.text('全選択');
    $this.removeClass('all_check');
    $this.addClass('all_uncheck');
}

function allUnCheck($this) {
    $this.text('選択解除');
    $this.removeClass('all_uncheck');
    $this.addClass('all_check');
}

function getScrollBottom() {
    let html = window.document.documentElement,
        scrollTop = window.document.body.scrollTop || html.scrollTop;

    return scrollTop + html.clientHeight;
}

/**
 * 入力条件での銘柄件数を取得し、書き換える
 */
let globalChangeFlg = true;
let countAjax;
function getStockCnt() {
    // globalLoadFlg->初期表示では実行させない
    if (globalLoadFlg) {
        // 実行中のAjaxを中断
        if (!globalChangeFlg && countAjax !== undefined) {
            countAjax.abort();
        }

        globalChangeFlg = false;
        globalLoadFlg = false;

        let formDetailParamList = $('form[name="screening"]').find(
            ':not(input[name=sa], input[name=screening])'
        );

        // formパラメータをJSON形式に変換
        let getParamList = (function(formDetailParamList) {
            let data = formDetailParamList.serializeArray(),
                returnJson = {},
                dataLength = data.length;

            for (let idx = 0; idx < dataLength; idx++) {
                returnJson[data[idx].name] = data[idx].value;
            }

            return returnJson;
        })(formDetailParamList);

        try {
            countAjax = $.ajax({
                url: $('#routeAjaxScreeningCount').val(),
                type: 'POST',
                cache: false,
                data: getParamList,
                dataType: 'text'
            })
                .done(function(ret) {
                    if (ret >= 0) {
                        // 件数書き換え
                        $('#detail_condition')
                            .find('.target_num .stock')
                            .text(ret);
                        $('nav .stock').text(ret);
                    }
                })
                .fail(function(jqXHR, textStatus, errorThrown) {
                    console.log(jqXHR, textStatus, errorThrown);
                })
                .always(function() {
                    // 連続動作させない
                    setTimeout(function() {
                        globalChangeFlg = true;
                    }, 100);
                });
        } catch (e) {
            console.log(e);
        } finally {
            globalLoadFlg = true;
        }
    }
}

/**
 * すべてクリア
 */
$(document).on('click', '.all_clear', function() {
    $.confirm({
        title: '削除確認',
        content: '現在入力されている条件を削除してよろしいですか？',
        closeIcon: true,
        type: 'orange',
        boxWidth: '500px',
        useBootstrap: false,
        backgroundDismiss: true,
        animation: 'top',
        buttons: {
            confirm: {
                text: 'OK',
                action: function() {
                    // 遷移前と同じURLだとリロードされないため、ランダム文字列を付与
                    location.href =
                        $('#routeScreeningSearch').val() +
                        '?' +
                        Math.random() +
                        '#top_active_json';
                }
            },
            cancel: {
                text: 'キャンセル'
            }
        }
    });
});

/**
 * 詳細条件行削除ボタン
 */
$(function() {
    let $row, rowId, id;
    $(document).on('click', '.row_delete', function() {
        $row = $(this).parents('.row');
        rowId = $row.attr('id');
        // 入力欄削除
        $row.remove();
        if (rowId !== undefined) {
            id = (function() {
                let split = rowId.split('_');
                return split[1] + '_' + split[2];
            })();
            // チェック状態を外す
            $('#' + id + ' input').iCheck('uncheck');
            // 銘柄件数を更新
            getStockCnt();
        }
    });
});

/**
 * Enterキーでのsubmitを無効化
 */
$(document).on('keydown', '#screening_condition input', function(e) {
    if ((e.which && e.which === 13) || (e.keyCode && e.keyCode === 13)) {
        return false;
    } else {
        return true;
    }
});

/**
 * チェックボックスにiCheck適用
 */
$('.check input[type="checkbox"]').iCheck({
    // チェックボックスのスタイル設定
    checkboxClass: 'icheckbox_flat-green'
});

/**
 * バルーン
 */
$(function() {
    let $condition = $('#screening_condition'),
        $result = $('#screening_result'),
        html,
        recommendListLength = $condition.find('.recommend_list .gallery')
            .length,
        cnt,
        offsetX = 0;

    /**
     * ギャラリーポップアップ balloon
     */
    // おすすめスクリーニング
    cnt = 0;
    $condition.find('.recommend_list .gallery').each(function() {
        html = $(this)
            .find('.gallery_balloon')
            .html();
        cnt++;

        // 画面端のballoon表示位置を調整する
        if (recommendListLength === cnt) {
            offsetX = -80;
        } else if (cnt === 1) {
            offsetX = 80;
        } else {
            offsetX = 0;
        }

        $(this).balloon({
            html: true,
            contents: html,
            showDuration: 0,
            hideDuration: 0,
            minLifetime: 0,
            position: 'bottom',
            offsetX: offsetX,
            tipSize: 14,
            classname: 'gallery_balloon'
        });
    });
});

/**
 * 条件入力欄の表示切替
 */
$(function() {
    let $condition = $('#screening_condition');

    /**
     * 条件入力欄ヘッダーをクリック時
     */
    $condition.find('.head').on('click', function() {
        if ($condition.find('.head .open').css('display') === 'block') {
            openConditionHead($condition);
        } else if ($condition.find('.head .close').css('display') === 'block') {
            closeConditionHead($condition);
        }
    });
});

/**
 * 条件変更ボタン 入力欄へ移動
 * @returns {undefined}
 */
$(function() {
    let position;

    $('.move_condition').on('click', function() {
        // 移動先を数値で取得
        position = $("#top_active_json").offset().top;
        // スムーススクロール
        $('body, html').animate({ scrollTop: position }, 250, 'swing');

        return false;
    });
});

/**
 * チェックボックスの全選択/解除
 */
$(function() {
    /**
     * 初期表示処理
     */
    $('#basic_condition')
        .find('.checkbox_toggle')
        .each(function() {
            let checked = true,
                $this = $(this);

            $(this)
                .closest('.input_area')
                .find('input[type="checkbox"]')
                .each(function() {
                    if ($(this).prop('checked')) {
                        // チェック状態
                        return true; // continue
                    } else {
                        // 未チェック状態
                        checked = false;
                        return false; // break
                    }
                });

            if (checked) {
                // すべて選択状態
                allUnCheck($this);
            } else {
                // 選択されていない項目あり
                allCheck($this);
            }
        });

    /**
     * ボタン押下時の処理
     */
    $(document).on('click', '.checkbox_toggle', function() {
        // 銘柄件数を更新させない
        globalLoadFlg = false;

        if ($(this).hasClass('all_uncheck')) {
            // すべて選択状態
            allUnCheck($(this));
            $(this)
                .closest('.input_area')
                .find('input')
                .iCheck('check');
        } else {
            // 選択されていない項目あり
            allCheck($(this));
            $(this)
                .closest('.input_area')
                .find('input')
                .iCheck('uncheck');
        }

        // 銘柄件数を更新
        globalLoadFlg = true;
        // 銘柄件数を書き換え
        getStockCnt();
    });
});

/**
 * 要素の監視
 */
$(function() {
    let $detailModal = $('#detail_modal');

    // 合計選択数を更新
    detailConditionCnt();

    // 詳細条件の選択中件数
    let detailConditionObserver = new MutationObserver(function(
        MutationRecords,
        MutationObserver
    ) {
        // モーダルヘッダの選択数値を更新
        categoryConditionCnt();

        // 合計選択数を更新
        detailConditionCnt();
    });

    // observer設定
    detailConditionObserver.observe($('.detail_condition_list').get(0), {
        childList: true
    });

    /**
     * モーダルヘッダのカテゴリ別選択数を更新
     */
    function categoryConditionCnt() {
        let cnt, $checkCnt;

        $detailModal
            .find('.modal_body')
            .children('.category')
            .each(function(idx) {
                cnt = $(this).find('input[type=checkbox]:checked').length;
                $checkCnt = $detailModal
                    .find('.modal_head .group')
                    .eq(idx)
                    .find('.check_cnt');

                $checkCnt.text(cnt);

                // 件数欄の表示非表示切り替え
                if (cnt > 0) {
                    $checkCnt.css('visibility', 'visible');
                } else {
                    $checkCnt.css('visibility', 'hidden');
                }
            });
    }

    /**
     * 選択された全要素の数を表示
     */
    function detailConditionCnt() {
        let checkedLength = $('.detail_condition_list')
            .children()
            .not('.sortable-drag').length; // 現在の選択数

        // 選択数書き換え
        $('.detail_cnt').text(checkedLength);

        if (checkedLength >= detailLimit) {
            // 選択上限に達したら文字色を変える
            $('.detail_cnt').addClass('maximum');
            // 選択無効化
            $('#detail_modal input:not(:checked)').iCheck('disable');
        } else {
            $('.detail_cnt').removeClass('maximum');
            // 選択有効化 制限項目は除外
            $('#detail_modal .row:not(.limit_screening) input:not(:checked)').iCheck(
                'enable'
            );
        }
    }
});

/**
 * モーダル
 */
$(function() {
    /**
     * モーダル動作スピード設定 fast/normal/slow ms
     * @constant
     * @type String|Number
     */
    const ANIMATION_SPEED = 'fast';

    let $detailModal = $('#detail_modal'),
        id;

    // 設定保存モーダル
    $(document).on('click', '.save_modal_open:not(.disable)', function() {
        let $admForm = $('#adm_form'),
            $saveModal = $('#save_modal');

        // 入力チェック
        if (!$admForm.validationEngine('validate')) {
            return false;
        }

        $saveModal
            .find('#adm_save_title')
            .text($admForm.find('input[name=title]').val());

        id = '#save_modal';
        // Modalを表示する
        $(this).blur();
        if ($('#modal_overlay')[0]) {
            return false;
        }
        $('body').append('<div id="modal_overlay"></div>');
        $('#modal_overlay').slideDown(ANIMATION_SPEED);
        // コンテンツをセンタリングする
        centeringModal(id);
        $(id).slideDown(ANIMATION_SPEED);

        $('#modal_overlay, .modal_close')
            .unbind()
            .on('click', (function() {
                $(id + ', #modal_overlay').slideUp(ANIMATION_SPEED, function() {
                    $('#modal_overlay').remove();
                });
            }));
    });

    // 詳細条件モーダル
    $('.detail_modal_open').on('click', function() {
        // 制限項目のチェックボックス無効化
        $('#detail_modal .row.limit_screening input').iCheck('disable');

        id = '#detail_modal';
        // Modalを表示する
        $(this).blur();
        if ($('#modal_overlay')[0]) {
            return false;
        }
        $('body').append('<div id="modal_overlay"></div>');
        $('#modal_overlay').slideDown(ANIMATION_SPEED);
        // コンテンツをセンタリングする
        centeringModal(id, true);
        $detailModal.slideDown(ANIMATION_SPEED);

        $('#modal_overlay, .modal_close')
            .unbind()
            .click(function() {
                $(id + ', #modal_overlay').slideUp(ANIMATION_SPEED, function() {
                    $('#modal_overlay').remove();
                });
            });
    });

    // モーダルヘッダクリック時の処理
    $detailModal.find('.group').on('click', function() {
        // ヘッダーのアクティブ状態を変更
        $detailModal.find('.group.active').removeClass('active');
        $(this).addClass('active');

        // チェックボックスリスト表示を切り替える
        let idx = $detailModal.find('.group').index(this);
        $detailModal.find('.category').removeClass('show');
        $detailModal
            .find('.category')
            .eq(idx)
            .addClass('show');
    });

    // リサイズされたらセンタリングする
    $(window).resize(centeringModal(id));
});

/**
 * 管理画面 条件設定をJSONへ保存
 */
$(function() {
    let formDetailParamList,
        getParamList,
        saveName,
        destination,
        procFlg = false, // 処理中フラグ
        adminFlg,
        $saveModal;

    $(document).on('click', '#save_modal .submit', function() {
        $saveModal = $('#save_modal');

        // 連打防止
        if (!procFlg && $saveModal.validationEngine('validate')) {
            procFlg = true;

            $saveModal.find('.save').hide();
            $saveModal.find('.now_save').show();

            adminFlg = lib.getQueryString('admin');

            formDetailParamList = $('form[name="screening"]').find(
                ':not(input[name=screening], input[name=jsonType], input[name=jsonId])'
            );

            // 保存名
            saveName = $('input[name="save_name"]').val();
            // 保存先JSON ID
            destination = $('select[name="destination"]').val();

            // formパラメータをJSON形式に変換
            getParamList = (function(formDetailParamList) {
                let data = formDetailParamList.serializeArray(),
                    returnJson = {},
                    dataLength = data.length;

                for (let idx = 0; idx < dataLength; idx++) {
                    returnJson[data[idx].name] = data[idx].value;
                }

                return returnJson;
            })(formDetailParamList);

            getParamList.save_name = saveName; // 保存名称
            getParamList.destination = destination; // 登録番号
            getParamList.admin = adminFlg; //管理者フラグ

            let $admForm = $('#adm_form');
            if (lib.getQueryString('jsonType') === 'recommend_new') {
                getParamList.destination = 'new';
            } else {
                getParamList.destination = lib.getQueryString('jsonId'); //登録番号
            }
            getParamList.save_name = $admForm
                .find('input[name=title]')
                .val();
            getParamList.icon = $admForm
                .find('input[name=icon]:checked')
                .val();
            getParamList.status = $admForm
                .find('input[name=status]:checked')
                .val();
            getParamList.type = $admForm
                .find('input[name=type]:checked')
                .val();
            getParamList.description = $admForm
                .find('textarea[name=description]')
                .val();
            getParamList.fromType = lib.getQueryString('jsonType');

            try {
                $.ajax({
                    url: $('#routeAjaxScreeningRegist').val(),
                    type: 'POST',
                    cache: false,
                    data: getParamList,
                    dataType: 'text'
                })
                    .done(function(retDestination) {
                        let regex = new RegExp(/^[0-9]+$/);

                        if (regex.test(retDestination)) {
                            window.location.href = $('#routeScreening').val();
                        } else {
                            $saveModal.find('.now_save').hide();
                            $saveModal.find('.save').show();
                            lib.jqAlert('処理エラー', retDestination);
                        }
                    })
                    .fail(function() {
                        $saveModal.find('.now_save').hide();
                        $saveModal.find('.save').show();
                        lib.jqAlert('処理エラー', '登録に失敗しました');
                    })
                    .always(function() {
                        procFlg = false;
                    });
            } catch (e) {
                console.log(e);
                procFlg = false;
            }
        }
    });
});

/**
 * ギャラリーの横スクロール位置を選択した場所まで移動させる
 *
 * @returns {undefined}
 */
$(function() {
    let $galleryList,
        $recommendScreeningStatusList,
        jsonType = lib.getQueryString('jsonType'),
        jsonId = lib.getQueryString('jsonId'),
        admin = lib.getQueryString('admin'),
        scrollOffset = 0,
        galleryWidth;

    // おすすめスクリーニング
    if (jsonType === 'recommend') {
        // 一般画面はおすすめスクリーニング非公開分のずれを補正してスクロールする
        if ( admin != 'true') {
            $recommendScreeningStatusList = JSON.parse($('#recommendScreeningStatusList').val()),
            scrollOffset = countPrivateUntilJsonId($recommendScreeningStatusList, jsonId);
        }

        $galleryList = $('#screening_condition').find(
            '.gallery_list.recommend_list'
        );
        scroll(scrollOffset);
    }

    // おすすめスクリーニングの非公開分をカウント
    function countPrivateUntilJsonId(recommendScreeningStatusList, jsonId) {
        let count = 0;
        for (let i = 0; i <= jsonId; i++) {
            if (recommendScreeningStatusList[i] === 0) { // 0:private(非公開)
                count++;
            }
        }
        return count;
    }

    function scroll(scrollOffset) {
        // 1ギャラリーの幅を取得
        galleryWidth = $galleryList.find('.gallery').outerWidth(true);
        // スクロール
        $galleryList.scrollLeft((jsonId - scrollOffset) * galleryWidth);
    }
});

/**
 * ページ読み込み時、詳細設定のチェック状態を変更
 */
$(function() {
    try {
        let inputDetailInitVal = getInitInput('detail'),
            id,
            $detail,
            $detailModal = $('#detail_modal');

        // ブラウザーから戻るボタンで遷移した時、遷移前のチェック状態が残ったままなので、一度リセットする

        // 戻るボタン対応
        $detailModal.find('input:checked').each(function() {
            $(this).iCheck('uncheck');
            $(this).iCheck('check');
        });

        $.each(inputDetailInitVal, function(idx, val) {
            id = val.id;

            // クリック
            if (
                $('#id_' + id)
                    .find('label input')
                    .prop('checked')
            ) {
                $('#id_' + id)
                    .find('label input')
                    .iCheck('uncheck');
                $('#id_' + id)
                    .find('label input')
                    .iCheck('check');
            } else {
                $('#id_' + id)
                    .find('label input')
                    .iCheck('check');
            }

            if (
                detailConfJson[id] === undefined ||
                detailConfJson[id].type === undefined
            ) {
                return true; // continue
            }

            $detail = $('#detail_id_' + id);

            // 入力タイプによって生成項目を制御
            switch (detailConfJson[id].type) {
                case 'A':
                    // type=number
                    initInputText(id, 1, val.value_1);
                    initInputText(id, 2, val.value_2);
                    break;
                case 'C':
                    // type=number
                    initInputText(id, 1, val.value_1);
                    initInputText(id, 2, val.value_2);
                    // type=radio
                    initInputRadio(id, val.value_3);
                    break;
                case 'E':
                    // type=number
                    initInputText(id, 1, val.value_1);
                    initInputText(id, 2, val.value_2);
                    // type=radio
                    initInputRadio(id, val.value_3);
                    break;
                case 'J':
                    // スライダー数値は、スライダー生成時に書き換え
                    break;
                case 'K':
                    // スライダー数値は、スライダー生成時に書き換え
                    // type=radio
                    initInputRadio(id, val.value_3);
                    break;
                case 'N':
                    //スライダー数値は、スライダー生成時に書き換え
                    //type=checkbox
                    initInputCheck(id, 3, val.value_3);
                    initInputCheck(id, 4, val.value_4);
                    initInputCheck(id, 5, val.value_5);
                    initInputCheck(id, 6, val.value_6);
                    break;
                default:
            }
        });

        function initInputText(id, key, data) {
            $detail.find('input[name=id_' + id + '_' + key + ']').val(data);
        }

        function initInputRadio(id, data) {
            if (detailConfJson[id]['radio'][data] === undefined) {
                data = detailConfJson[id]['radioChecked'];
            }

            $('#radio_id_' + id + '_' + data).prop('checked', true);
        }

        function initInputCheck(id, key, data) {
            let iCheck;
            if (data == 1) {
                iCheck = 'check';
            } else {
                iCheck = 'uncheck';
            }

            $detail
                .find('input[name=id_' + id + '_' + key + ']')
                .iCheck(iCheck);
        }
    } catch (e) {
        console.log(e);
    } finally {
        // 制限項目のチェックボックス無効化 既にチェック済みのものは除外
        $('#detail_modal .row.limit_screening input:not(:checked)').iCheck('disable');

        globalLoadFlg = true;
        getStockCnt();
    }
});

/**
 * 入力条件変更監視
 */
$(window).on('load', function() {
    let pow,
        value,
        roundConf = getScreeningConf('round'); // 有効小数点桁数

    if (roundConf === null || roundConf === undefined || !lib.isNumber(roundConf)) {
        roundConf = 3;
    }

    // 入力条件が変わった時 ifChanged=iCheck用
    $(document).on(
        'change ifChanged',
        'form[name="screening"] input, form[name="screening"] select',
        function() {
            value = $(this).val();

            // 入力された小数点桁を丸める
            if (lib.isNumber(value)) {
                pow = Math.pow(10, roundConf);
                value = Math.round(value * pow) / pow;
                $(this).val(value);
            }

            // 銘柄件数を取得、書き換え
            getStockCnt();
        }
    );
});

/**
 * フッター追従スクロール
 */
let footerScrollFlg = true; // フッター追従スクロール制御フラグ

// ページロード時はフッター追従スクロールを抑止
$(function() {
    footerScrollFlg = false;

    $(window).on('load', function() {
        setTimeout(function() {
            footerScrollFlg = true;
        }, 2000);
    });
});

// フッター追従スクロールメイン処理
$(window).on('load', function() {
    // スクロール開始位置
    let $start = $('.input_area.market');

    if ($start.length === 0) {
        return;
    }

    let $window = $(window),
        $fixedEnd = $('#fixed_end'),
        $nav = $('nav'),
        showClass = 'is-show',
        startTop = $start.offset().top,
        fixedEndTop = $fixedEnd.offset().top,
        windowWidth = $window.width(),
        windowBottom = getScrollBottom(),
        contentWidth = $('#head').width() || 1020; // 横幅

    // スクロールイベント
    $window.on('scroll', function() {
        // 処理を間引く
        if (footerScrollFlg) {
            footerScrollFlg = false;

            setTimeout(function() {
                windowBottom = getScrollBottom(); //ウィンドウの下部分の位置
                fixedEndTop = $fixedEnd.offset().top; //固定を終わらせる位置
                if (
                    windowWidth > contentWidth &&
                    windowBottom > startTop &&
                    windowBottom < fixedEndTop
                ) {
                    $nav.addClass(showClass);
                } else {
                    $nav.removeClass(showClass);
                }

                footerScrollFlg = true;
            }, 90);
        }
    });

    $window.on('load resize', function() {
        windowBottom = getScrollBottom();
        windowWidth = $(window).width();
        if (
            windowWidth > contentWidth &&
            windowBottom > startTop &&
            windowBottom < fixedEndTop
        ) {
            $nav.addClass(showClass);
        } else {
            $nav.removeClass(showClass);
        }
    });

    // スクリーニング条件を変更しない場合のアンカーリンクずれ補正
    $(document).on('click', '#detail_condition .submit', function() {
        // フッターを消去
        $nav.removeClass(showClass);

        // フッター追従スクロールを一時的に抑止
        footerScrollFlg = false;
        setTimeout(function() {
            footerScrollFlg = true;
        }, 100);
    });
});

/**
 * 画面の読み込みが完了するまでスクリーニングボタンを押下させない
 */
$(window).on('load', function() {
    $('.footer .submit').prop('disabled', false);
});

// 基礎条件のバリデーションチェック
$(function() {
    //条件入力欄
    $('form[name="screening"]').validationEngine({
        promptPosition: 'topRight'
    });
});

/**
* キーワード入力チェック
*/
window.checkInputKeyWord = function checkInputKeyWord(field, rules, i, options) {
    let message = '',
        keywordArray = field.val().trim().replaceAll('　', ' ').split(' ');

    keywordArray.filter(Boolean); // 配列の空データを削除
    keywordArray.forEach(function(val,index,ar) {
    if (val != '' && val.length < 2) {
        message = '単語は2文字以上にしてください';
    }
    });
    if (message !== '') {
        return message;
    }
}

// 記号を含む文字列でのスクリーニング実行時のエラー表示
$(function () {
    $('form').on('submit', function (e) {
        const keyword = lib.toHankaku($(this).find('input[name="keyword"]').val()).trim();

        // 禁止記号(半角スペース以外)
        const invalidChars = /[-\/:-@\[\\\]^_`{|}~]/;

        // !と&を空文字に置換
        const checkStr = keyword.replace(/[!&]/g, '');

        // !,&,半角スペース以外の記号を検出してエラー表示
        if (invalidChars.test(checkStr)) {
            e.preventDefault();
            lib.jqAlert('キーワード入力エラー', 'キーワードに記号は入力できません。');
            return false;
        }
    });
});

/**
 * 権利確定月の切り替え
 */
$(function() {
    $('.shareholder .check input[type="checkbox"]').change(function() {
        let isChecked = $(this).is(':checked');
        if (isChecked) {
            $('.vm').show();
        } else {
            $('.vm').hide();
        }
    });
});

/**
 * 権利確定月の切り替え（画面ロード時）
 */
$(window).on('load', function() {
    if ($('.shareholder .check input[type="checkbox"]').is(':checked')) {
        $('.vm').show();
    } else {
        $('.vm').hide();
    }
});
